var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_c('a',{staticClass:"phone-tag",attrs:{"text":"","href":_vm.telephoneRef},on:{"click":_vm.onPhoneNumber}},[_vm._v(_vm._s(_vm.phone))])])}
var staticRenderFns = []

export { render, staticRenderFns }